module.exports = __webpack_public_path__ + "img/technology_thumbnail-1.8de08663.jpg";